import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { TableHeader } from "../../commons";
import ScrollToTop from "../../commons/ScrollToTop";
import AgeingAnalysisTableData from "./AgeingAnalysisTableData";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
import { AgeingAnalysisReportListType } from "../../../redux/reports/reportsType";
import { currencySignAndNegativeValueAdjust } from "../../../utils/commonFunctions";

type AppProps = {
  tableHeaders: TableHeadersType[];
  tableData: AgeingAnalysisReportListType[] | [];
  clientCode: number;
  companyName: string;
  fetching: boolean;
  offset: number;
  currencySign: string | undefined;
  ageingAnalysis0To30DaysTotal: number;
  ageingAnalysis30To60DaysTotal: number;
  ageingAnalysis60To90DaysTotal: number;
  ageingAnalysisMoreThan90DaysTotal: number;
  ageingAnalysisTotalOfTotal: number;
};
const AgeingAnalysisTable = ({
  tableHeaders,
  tableData,
  clientCode,
  companyName,
  fetching,
  offset,
  currencySign,
  ageingAnalysis0To30DaysTotal,
  ageingAnalysis30To60DaysTotal,
  ageingAnalysis60To90DaysTotal,
  ageingAnalysisMoreThan90DaysTotal,
  ageingAnalysisTotalOfTotal,
}: AppProps) => {
  return (
    <div className="jobsType">
      <table className="table table-bordered thead-light">
        <thead className="text-start sticky-table-header">
          <tr className="new-table-head" style={{ fontSize: "11px" }}>
            <td colSpan={2}>
              <strong>Total Amount</strong>
            </td>
            <td colSpan={1}>
              <strong>
                {typeof ageingAnalysis0To30DaysTotal === "number" &&
                ageingAnalysis0To30DaysTotal
                  ? currencySignAndNegativeValueAdjust(
                      currencySign,
                      ageingAnalysis0To30DaysTotal.toFixed(2)
                    )
                  : currencySignAndNegativeValueAdjust(currencySign, "0")}
              </strong>
            </td>
            <td colSpan={1}>
              <strong>
                {typeof ageingAnalysis30To60DaysTotal === "number" &&
                ageingAnalysis30To60DaysTotal
                  ? currencySignAndNegativeValueAdjust(
                      currencySign,
                      ageingAnalysis30To60DaysTotal.toFixed(2)
                    )
                  : currencySignAndNegativeValueAdjust(currencySign, "0")}
              </strong>
            </td>
            <td colSpan={1}>
              <strong>
                {typeof ageingAnalysis60To90DaysTotal === "number" &&
                ageingAnalysis60To90DaysTotal
                  ? currencySignAndNegativeValueAdjust(
                      currencySign,
                      ageingAnalysis60To90DaysTotal.toFixed(2)
                    )
                  : currencySignAndNegativeValueAdjust(currencySign, "0")}
              </strong>
            </td>
            <td colSpan={1}>
              <strong>
                {typeof ageingAnalysisMoreThan90DaysTotal === "number" &&
                ageingAnalysisMoreThan90DaysTotal
                  ? currencySignAndNegativeValueAdjust(
                      currencySign,
                      ageingAnalysisMoreThan90DaysTotal.toFixed(2)
                    )
                  : currencySignAndNegativeValueAdjust(currencySign, "0")}
              </strong>
            </td>
            <td colSpan={1}>
              <strong>
                {typeof ageingAnalysisTotalOfTotal === "number" &&
                ageingAnalysisTotalOfTotal
                  ? currencySignAndNegativeValueAdjust(
                      currencySign,
                      ageingAnalysisTotalOfTotal.toFixed(2)
                    )
                  : currencySignAndNegativeValueAdjust(currencySign, "0")}
              </strong>
            </td>
          </tr>
          <TableHeader tableHeader={tableHeaders} />
        </thead>
        <tbody>
          <AgeingAnalysisTableData
            tableHeaders={tableHeaders}
            tableData={tableData}
            clientCode={clientCode}
            companyName={companyName}
            currencySign={currencySign}
          />
          {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}

          <div style={{ display: fetching ? "none" : "inline" }}>
            <ScrollToTop />
          </div>
        </tbody>
      </table>
    </div>
  );
};

export default AgeingAnalysisTable;
